import { Box, Center, Text } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import Modal from "react-modal";

export function ModalMsg({ message, setMessage }) {
  return (
    <Modal
      className="react-modal-content-ordenacao"
      overlayClassName="react-modal-overlay-ordenacao"
      isOpen={message}
      onRequestClose={() => setMessage("")}
    >
      <Box paddingX="1rem" paddingTop="2rem">
        <button
          type="button"
          onClick={() => setMessage("")}
          className="react-modal-close-ordenacao"
        >
          <FaTimes color="#3E4047" size={18} />
        </button>
        <Center>
          <Text fontSize="1.25rem" paddingX="0.5rem" fontWeight="normal">
            {message}
          </Text>
        </Center>
      </Box>
    </Modal>
  );
}
